"use client";
import{createContext as o}from"react";const t=o({registerOption:void 0,selectActions:void 0});export{t as SelectContext};
